const ListaOtrosSignos = {
    Initialize() {
        const $section = document.querySelector('.otrosSignos');

        if ($section === null)
            return;

        let FadeInArticle = (element) => {
            let num = 0;
            Array.from(element).map((item) => {
                item.classList.add("zoomIn");
                item.style.animationDelay = num + 's';
                num += 0.1;
            });
        };

        const $article = document.querySelectorAll('.otrosSignos__lista__signo');
        let PANTALLA_ARRIBA = window.pageYOffset;
        let PANTALLA_TAMANIO_Y = window.innerHeight;
        let PANTALLA_BOTTOM = PANTALLA_ARRIBA + PANTALLA_TAMANIO_Y;

        if (PANTALLA_BOTTOM > $section.offsetTop) {
            FadeInArticle($article);
        }

        document.addEventListener('scroll', () => {
            PANTALLA_TAMANIO_Y = window.innerHeight;
            PANTALLA_ARRIBA = window.pageYOffset;
            PANTALLA_BOTTOM = PANTALLA_ARRIBA + PANTALLA_TAMANIO_Y;

            if (PANTALLA_BOTTOM > $section.offsetTop) {
                FadeInArticle($article);
                return false;
            }
        });
    }
};

export default ListaOtrosSignos;


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/ListaOtrosSignos.js